import { render, staticRenderFns } from "./catShare.vue?vue&type=template&id=49e3a3a2&scoped=true"
import script from "./catShare.vue?vue&type=script&lang=js"
export * from "./catShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e3a3a2",
  null
  
)

export default component.exports